<form (submit.prevent)="onChangeFilter()">
  <div class="flex md:grid grid-cols-3 gap-3">
    <ui-input-simple
      class="flex-1"
      type="search"
      [placeholder]="'cockpit.documents.filterForm.searchPlaceholder' | transloco"
      [attr.aria-label]="'cockpit.documents.filterForm.searchPlaceholder' | transloco"
      [debounceMs]="200"
      [formField]="filterForm.data.filename"
      (fieldValueChange)="onChangeFilter()"
    >
      <div slot="start" class="text-on-surface-disabled dark:text-on-surface-disabled-darkmode">
        <ng-icon name="heroMagnifyingGlass" size="16" class="!block" />
      </div>
    </ui-input-simple>
    <ui-select
      class="hidden md:inline"
      [attr.aria-label]="'cockpit.documents.filterForm.categoryLabel' | transloco"
      [formField]="filterForm.data.fileType"
      (selectChange)="onChangeFilter()"
    >
      <option value="">{{ 'cockpit.documents.filterForm.allCategories' | transloco }}</option>
      <option
        value="LMA_LOCATION_ANALYSIS"
        [selected]="
          filterForm.data.fileType().value() === 'LMA_LOCATION_ANALYSIS' ? 'selected' : null
        "
      >
        {{ 'cockpit.documents.filterForm.fileType.lmaLocationAnalysis' | transloco }}
      </option>
      <option
        value="SUPPLIER_CONTRACT"
        [selected]="filterForm.data.fileType().value() === 'SUPPLIER_CONTRACT' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.fileType.supplierContract' | transloco }}
      </option>
      <option
        value="SUPPLIER_INVOICE"
        [selected]="filterForm.data.fileType().value() === 'SUPPLIER_INVOICE' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.fileType.supplierInvoice' | transloco }}
      </option>
      <option
        value="ORGANIZATION_PROFILE"
        [selected]="
          filterForm.data.fileType().value() === 'ORGANIZATION_PROFILE' ? 'selected' : null
        "
      >
        {{ 'cockpit.documents.filterForm.fileType.organizationProfile' | transloco }}
      </option>
      <option
        value="LMA_OTHER"
        [selected]="filterForm.data.fileType().value() === 'LMA_OTHER' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.fileType.lmaOther' | transloco }}
      </option>
      <option
        value="LMA_BATTERY_SIMULATION"
        [selected]="
          filterForm.data.fileType().value() === 'LMA_BATTERY_SIMULATION' ? 'selected' : null
        "
      >
        {{ 'cockpit.documents.filterForm.fileType.lmaBatterySimulation' | transloco }}
      </option>
      <option
        value="LMA_GRID_USAGE_OPTIMIZATION"
        [selected]="
          filterForm.data.fileType().value() === 'LMA_GRID_USAGE_OPTIMIZATION' ? 'selected' : null
        "
      >
        {{ 'cockpit.documents.filterForm.fileType.lmaGridUsageOptimization' | transloco }}
      </option>
      <option
        value="LMA_LOAD_SIMULATION"
        [selected]="
          filterForm.data.fileType().value() === 'LMA_LOAD_SIMULATION' ? 'selected' : null
        "
      >
        {{ 'cockpit.documents.filterForm.fileType.lmaLoadSimulation' | transloco }}
      </option>
      <option
        value="UNKNOWN"
        [selected]="filterForm.data.fileType().value() === 'UNKNOWN' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.fileType.unknown' | transloco }}
      </option>
    </ui-select>
    <ui-select
      class="hidden md:inline"
      [attr.aria-label]="'cockpit.documents.filterForm.mimeTypeLabel' | transloco"
      [formField]="filterForm.data.mimeType"
      (selectChange)="onChangeFilter()"
    >
      <option value="">{{ 'cockpit.documents.filterForm.allMimeTypes' | transloco }}</option>
      <option
        value="image/"
        [selected]="filterForm.data.mimeType().value() === 'image/' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.images' | transloco }}
      </option>
      <option
        value="application/pdf"
        [selected]="filterForm.data.mimeType().value() === 'application/pdf' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.pdf' | transloco }}
      </option>
      <option
        value="video/"
        [selected]="filterForm.data.mimeType().value() === 'video/' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.videos' | transloco }}
      </option>
      <option
        value="audio/"
        [selected]="filterForm.data.mimeType().value() === 'audio/' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.audio' | transloco }}
      </option>
      <option
        value="text/csv"
        [selected]="filterForm.data.mimeType().value() === 'text/csv' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.csv' | transloco }}
      </option>
      <option
        value="application/zip"
        [selected]="filterForm.data.mimeType().value() === 'application/zip' ? 'selected' : null"
      >
        {{ 'cockpit.documents.filterForm.mimeType.archive' | transloco }}
      </option>
    </ui-select>
    <ui-button
      mode="outlined"
      [iconOnly]="true"
      class="md:hidden flex-none"
      (click)="hiddenFilter.showModal()"
    >
      <ng-icon name="heroFunnel" size="20" class="!block" />
    </ui-button>
  </div>
  <ui-simple-dialog #hiddenFilter>
    <ui-simple-dialog-layout (clickCancel)="hiddenFilter.close()" class="w-full block">
      <ng-container slot="title"> Weitere Filter </ng-container>
      <div class="flex flex-col gap-6">
        <ui-select
          [attr.aria-label]="'cockpit.documents.filterForm.categoryLabel' | transloco"
          [formField]="filterForm.data.fileType"
          (selectChange)="onChangeFilter()"
        >
          <option value="">{{ 'cockpit.documents.filterForm.allCategories' | transloco }}</option>
          <option
            value="LMA_LOCATION_ANALYSIS"
            [selected]="
              filterForm.data.fileType().value() === 'LMA_LOCATION_ANALYSIS' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaLocationAnalysis' | transloco }}
          </option>
          <option
            value="SUPPLIER_CONTRACT"
            [selected]="
              filterForm.data.fileType().value() === 'SUPPLIER_CONTRACT' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.supplierContract' | transloco }}
          </option>
          <option
            value="SUPPLIER_INVOICE"
            [selected]="
              filterForm.data.fileType().value() === 'SUPPLIER_INVOICE' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.supplierInvoice' | transloco }}
          </option>
          <option
            value="ORGANIZATION_PROFILE"
            [selected]="
              filterForm.data.fileType().value() === 'ORGANIZATION_PROFILE' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.organizationProfile' | transloco }}
          </option>
          <option
            value="LMA_OTHER"
            [selected]="filterForm.data.fileType().value() === 'LMA_OTHER' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaOther' | transloco }}
          </option>
          <option
            value="LMA_BATTERY_SIMULATION"
            [selected]="
              filterForm.data.fileType().value() === 'LMA_BATTERY_SIMULATION' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaBatterySimulation' | transloco }}
          </option>
          <option
            value="LMA_GRID_USAGE_OPTIMIZATION"
            [selected]="
              filterForm.data.fileType().value() === 'LMA_GRID_USAGE_OPTIMIZATION'
                ? 'selected'
                : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaGridUsageOptimization' | transloco }}
          </option>
          <option
            value="LMA_LOAD_SIMULATION"
            [selected]="
              filterForm.data.fileType().value() === 'LMA_LOAD_SIMULATION' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaLoadSimulation' | transloco }}
          </option>
          <option
            value="UNKNOWN"
            [selected]="filterForm.data.fileType().value() === 'UNKNOWN' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.fileType.unknown' | transloco }}
          </option>
        </ui-select>
        <ui-select
          [attr.aria-label]="'cockpit.documents.filterForm.mimeTypeLabel' | transloco"
          [formField]="filterForm.data.mimeType"
          (selectChange)="onChangeFilter()"
        >
          <option value="">{{ 'cockpit.documents.filterForm.allMimeTypes' | transloco }}</option>
          <option
            value="image/"
            [selected]="filterForm.data.mimeType().value() === 'image/' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.mimeType.images' | transloco }}
          </option>
          <option
            value="application/pdf"
            [selected]="
              filterForm.data.mimeType().value() === 'application/pdf' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.mimeType.pdf' | transloco }}
          </option>
          <option
            value="video/"
            [selected]="filterForm.data.mimeType().value() === 'video/' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.mimeType.videos' | transloco }}
          </option>
          <option
            value="audio/"
            [selected]="filterForm.data.mimeType().value() === 'audio/' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.mimeType.audio' | transloco }}
          </option>
          <option
            value="text/csv"
            [selected]="filterForm.data.mimeType().value() === 'text/csv' ? 'selected' : null"
          >
            {{ 'cockpit.documents.filterForm.mimeType.csv' | transloco }}
          </option>
          <option
            value="application/zip"
            [selected]="
              filterForm.data.mimeType().value() === 'application/zip' ? 'selected' : null
            "
          >
            {{ 'cockpit.documents.filterForm.mimeType.archive' | transloco }}
          </option>
        </ui-select>
      </div>
    </ui-simple-dialog-layout>
  </ui-simple-dialog>
</form>
